export default __webpack_public_path__ + "css/purchase.bundle.css";